import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ 
  icon: Icon, 
  title, 
  description, 
  action,
  className 
}: EmptyStateProps) {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center py-16 px-4 text-center",
      "animate-fade-in",
      className
    )}>
      <div className="relative mb-6">
        {/* Floating icon with pulse effect */}
        <div className="absolute inset-0 rounded-full bg-primary/20 blur-2xl animate-pulse" />
        <div className="relative rounded-full bg-gradient-to-br from-primary/20 to-secondary/20 p-6 animate-float">
          <Icon className="w-12 h-12 text-primary" strokeWidth={1.5} />
        </div>
      </div>
      
      <h3 className="text-2xl font-heading font-bold mb-2 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
        {title}
      </h3>
      
      {description && (
        <p className="text-muted-foreground max-w-md mb-6 leading-relaxed">
          {description}
        </p>
      )}
      
      {action && (
        <div className="animate-fade-in" style={{ animationDelay: '0.2s' }}>
          {action}
        </div>
      )}
    </div>
  );
}
